import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/video/')({
  component: VideoPage,
})

function VideoPage() {
  return (
    <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight text-primary">Video Lab</h1>
      <p className="text-sm text-muted-foreground">
        Text-to-video, image-to-video, and motion remix pipelines are on the roadmap. This surface will evolve into a
        control room for those workflows as soon as the backend pieces are in place.
      </p>
    </div>
  )
}
